import { ClientEmailsField as SharedClientEmailsField, type ClientEmailsFieldProps } from '@overlayqa/shared/ui';
import { capture } from '@/lib/analytics';
export { cleanClientEmails, EmailList, MAX_CLIENT_EMAILS } from '@overlayqa/shared/ui';

/** Dashboard analytics adapter; markup and behavior live in shared UI. */
export function ClientEmailsField(props: ClientEmailsFieldProps) {
  return <SharedClientEmailsField {...props} onEvent={capture} />;
}
